import { render, staticRenderFns } from "./FollowUpAppointment.vue?vue&type=template&id=eb42c394&scoped=true"
import script from "./FollowUpAppointment.vue?vue&type=script&lang=js"
export * from "./FollowUpAppointment.vue?vue&type=script&lang=js"
import style0 from "./FollowUpAppointment.vue?vue&type=style&index=0&id=eb42c394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb42c394",
  null
  
)

export default component.exports